import brandConfig from "../config/brandConfig";

const SENTRY_DSN =
	"https://24e8c77e7e648c827a5472c1d0f17d8a@o4508184186257408.ingest.de.sentry.io/4508185350438992";

let sentryInitPromise = null;
let sentryInitialized = false;

const initSentry = async () => {
	const Sentry = await import("@sentry/react");
	Sentry.init({
		dsn: SENTRY_DSN,
		integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
		tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0,
		tracePropagationTargets: [
			"localhost",
			/^https:\/\/europe-west3-[^.]+\.cloudfunctions\.net\//,
		],
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		initialScope: {
			tags: {
				brand: brandConfig.id,
				productProfile: brandConfig.productProfile,
			},
		},
	});
	sentryInitialized = true;
	return true;
};

export const initializeSentry = async (hasConsent) => {
	if (!hasConsent) {
		return false;
	}

	if (sentryInitPromise) {
		return sentryInitPromise;
	}

	sentryInitPromise = initSentry().catch((error) => {
		sentryInitPromise = null;
		throw error;
	});

	return sentryInitPromise;
};

export const disableSentry = async () => {
	if (!sentryInitialized && !sentryInitPromise) {
		return;
	}

	try {
		const Sentry = await import("@sentry/react");
		if (typeof Sentry.close === "function") {
			await Sentry.close(2000);
		} else if (typeof Sentry.flush === "function") {
			await Sentry.flush(2000);
		}
	} catch (error) {
		console.error("[sentryService][disableSentry] - Error disabling Sentry:", error);
	}

	sentryInitialized = false;
	sentryInitPromise = null;
};
